import { React, useRef, useEffect, useState } from "react";
// import ReactSelect from "react-select";
import styled from "styled-components";
import FormikSelect from "../Formik/FormikSelect";
import FormikInput from "../Formik/FormikInput";
import FormikSelectWithModel from "../Formik/FormikSelectWithModal/FormikSelectWithModel";
import { alternativeProductsLoadMoreTableHeading } from "../../utilities/constants";
import { useLanguage } from "../LangTranslation/LanguageContext";
import Translator from "./Translator";
import { primaryColor } from "../../utilities/colors";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import DropdownTreeSelect from "react-dropdown-tree-select";
import { useFormikContext } from "formik";

const ECommerceContainer = styled.div`
  margin: 15px 0px 40px 0px;
  padding: 14px 10px 14px 10px;

  .DescriptionBox {
    margin: 10px 0px 0px 25px;
    padding: 10px;
    width: 800px !important;
    border: 1px solid #cbcbcb;
    height: 160px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  .shop_text {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    color:#4E5D78;
    margin-bottom:10px;
  }
`;
const ECommerce = ({
  formData,
  productId,
  fieldName,
  fieldValue,
  isCreateModalOpen,
  setIsCreateModalOpen,
  updatedData,
  productList,
  setUpdatedData,
  disabled,
  publicCategoriesList,
  setPublicCategoriesList,
  handleCreatePublicCategory,
  handleCustomSearch,
  productBrand,
  handleCreateBrand,
  setProductBrand,
  company_id,
}) => {

  const { language, translations } = useLanguage();
  const t = translations[language];
  const dropdownRef = useRef(null);
  const wrapperRef = useRef(null);
  const { setFieldValue, setFieldTouched, errors, touched } =
    useFormikContext();
  const [placeholder, setPlaceholder] = useState("Search or Select...");
  const preProcessNodes = (nodesList) => {
    if (nodesList?.length === 0) return [];
    return nodesList.map((node) => {
      return {
        ...node,
        checked: false,
        children: preProcessNodes(node.children || []),
      };
    });
  };

  const checkSelectedNode = (
    currentNode,
    nodeList,
    parentFound = false,
    parentSkip = false
  ) => {
    let currentSkip = parentSkip;
    let currentFound = parentFound;
    const list = nodeList.map((op) => {
      if (currentNode.value === op.value) {
        currentFound = true;
        currentSkip = true;

        return { ...op, checked: currentNode.value, expanded: false };
      } else {
        if (currentSkip) return { ...op, expanded: false, checked: false };
        let childList = [];
        if (op?.children?.length > 0) {
          const { list, childFound, childSkip } = checkSelectedNode(
            currentNode,
            op.children,
            currentFound,
            currentSkip
          );
          currentFound = childFound;
          childList = list;
          currentSkip = childSkip;
        }
        return {
          ...op,
          children: childList,
          checked: false,
          expanded: currentFound,
        };
      }
    });
    return {
      list,
      childFound: currentFound,
      childSkip: currentSkip,
    };
  };
  const onChange = (currentNode, selectedNodes) => {
    const preprocessedListOptions = preProcessNodes(publicCategoriesList);

    // Update visual tag
    if (currentNode.checked) {
      const { list } = checkSelectedNode(
        currentNode,
        preprocessedListOptions,
        false
      );

      setTimeout(() => {
        const tag = document.getElementById(`${currentNode._id}_tag`);
        if (tag) {
          tag.childNodes[0].replaceWith(currentNode.tag_to_show);
        }
      }, 100);
      setPublicCategoriesList(JSON.parse(JSON.stringify(list)));
    } else {
      setPublicCategoriesList(preprocessedListOptions);
    }

    // ✅ This ensures Formik gets the full array of selected values
    const selectedValues = selectedNodes.map((node) => node.value);
    setFieldValue("public_categ_ids", selectedValues);

    setPlaceholder(selectedValues.length > 0 ? " " : "Search or Select...");

    // Close the dropdown
    if (dropdownRef.current) {
      dropdownRef.current.setState({
        ...dropdownRef.current.state,
        showDropdown: false,
      });
    }
  };

  const handleClickOutside = (event) => {
    // console.log("first", wrapperRef.current, event.target);

    if (dropdownRef.current && !wrapperRef.current.contains(event.target)) {
      dropdownRef.current.setState({
        ...dropdownRef.current.state,
        showDropdown: false, // Set dropdown state to closed
      });
    }
  };

  // Attach and clean up the click outside listener
  useEffect(() => {
    // console.log("formData", formData);
    if (formData?.public_categ_ids.length > 0) {
      setPlaceholder(" ");
    } else {
      setPlaceholder("Search or Select...");
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <ECommerceContainer>
      <div className="row">
        <div className="shop_text">{t["Shop"]}</div>
        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            options={publicCategoriesList}
            label={t["Categories"]}
            name="public_categ_ids"
            isMulti
            handleSearch={({ ...args }) => {
              handleCustomSearch({
                ...args,
                model: "product.public.category",
                args: [["website_id.company_id", "=", company_id]],
              });
            }}
            onChange={(op) => {
              // console.log(op, "public_categ_ids.......................");
              findAndAddOption({
                incomingOption: [op.value, op.label],
                setAvailableOptions: setPublicCategoriesList,
              });
            }}
            handleCreate={handleCreatePublicCategory}
          />
        </div>
        {/* 
        <div ref={wrapperRef} id="treeDropdownWrapper" className="col-md-6">
          <label
            htmlFor="public_categ_ids"
            className="form-label"
            style={{
              color: "#535559",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "500",
              marginRight: "10px",
            }}
          >
            {t["Categories"]}
          </label>
          <DropdownTreeSelect
            ref={dropdownRef}
            name="public_categ_ids"
            disabled={disabled}
            data={publicCategoriesList}
            mode="hierarchical"
            onChange={onChange}
            // searchPredicate={() => {
            //   console.log("first");
            // }}
            className="tree-select"
            texts={{
              placeholder,
            }}
            styles={{
              minHeight: "58px",
              borderRadius: "15px",
              border: "1px solid #CBCBCB",
              background: "#F5F5F5",
              boxShadow: "0 !important",
              "&:hover": {
                border: "1px solid #CBCBCB !important",
              },
            }}
          />
          {touched["public_categ_ids"] && errors["public_categ_ids"] && (
            <span className="ps-2 error-message">
              {errors["public_categ_ids"]}
            </span>
          )}
        </div> */}

        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            options={productBrand}
            placeholder="Search or Select..."
            name="brand_id"
            label={t["Product Brand"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({ ...args, model: "product.template.brand" })
            }
            onChange={(op) => {
              // console.log(op, "VtexBrand");
              findAndAddOption({
                incomingOption: [op.value, op.label],
                setAvailableOptions: setProductBrand,
              });
            }}
            handleCreate={handleCreateBrand}
          />
        </div>

        <div
          className="col-md-12 d-flex flex-column"
          style={{ position: "relative" }}
        >
          {!disabled && (
            <Translator
              productId={productId}
              color={primaryColor.primary}
              fieldName={fieldName}
              fieldValue={fieldValue}
              isCreateModalOpen={isCreateModalOpen}
              setIsCreateModalOpen={setIsCreateModalOpen}
              updatedData={updatedData}
              setUpdatedData={setUpdatedData}
            />
          )}
          <FormikInput
            disabled={disabled}
            maxLength="150"
            textArea
            name="description_sale"
            label={t["Description"] + " (limit: 150 words)"}
          />
        </div>
      </div>
    </ECommerceContainer>
  );
};

export default ECommerce;
